import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
function animatePopover(state) {
    switch (state) {
        case 'hidden':
            return css `
        display: none;
        transform: translate(0, 0.25rem);
        opacity: 0;
      `;
        case 'entering':
        case 'leaving':
            return css `
        transform: translate(0, 0.25rem);
        opacity: 0;
        display: flex;
      `;
        default:
            return css `
        transform: translate(0, 0);
        opacity: 1;
        display: flex;
      `;
    }
}
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.primary};
  box-shadow: ${(props) => theme.dropShadow[props.$shadow]};
  padding: ${(props) => (props.$padding === 0 ? 0 : theme.spacing[props.$padding])};
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  ${(props) => animatePopover(props.$state)};
  transition:
    opacity ${theme.motion.duration.fast} ${theme.motion.easing.standard},
    transform ${theme.motion.duration.fast} ${theme.motion.easing.standard};
`;
